import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import Icon from '../Icon';
import './style.scss';
var Tag = function Tag(_ref) {
  var name = _ref.name,
    stretchClickableArea = _ref.stretchClickableArea,
    deleteButtonAriaLabel = _ref.deleteButtonAriaLabel,
    className = _ref.className,
    onDelete = _ref.onDelete,
    link = _ref.link,
    onClick = _ref.onClick,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '_blank' : _ref$target,
    iconName = _ref.iconName,
    _ref$iconFlair = _ref.iconFlair,
    iconFlair = _ref$iconFlair === void 0 ? 'outlined' : _ref$iconFlair;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleOnClick = function handleOnClick(e) {
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };
  var renderMainInteractivePart = function renderMainInteractivePart() {
    if (link) {
      return /*#__PURE__*/React.createElement("a", {
        href: link,
        target: target,
        className: "Tag__link",
        onClick: onClick ? handleOnClick : undefined
      }, /*#__PURE__*/React.createElement("span", {
        className: "Tag__name"
      }, name));
    }
    if (onClick) {
      return /*#__PURE__*/React.createElement("button", {
        className: "Tag__button",
        onClick: handleOnClick,
        type: "button"
      }, /*#__PURE__*/React.createElement("span", {
        className: "Tag__name"
      }, name));
    }
    return /*#__PURE__*/React.createElement("span", {
      className: "Tag__name"
    }, name);
  };
  var tagClasses = c('Tag', {
    'Tag--stretch-clickable-area': stretchClickableArea
  }, className);
  return /*#__PURE__*/React.createElement("div", {
    className: tagClasses
  }, renderMainInteractivePart(), iconName && /*#__PURE__*/React.createElement(Icon, {
    className: "Tag__icon",
    name: iconName,
    flair: iconFlair
  }), onDelete && /*#__PURE__*/React.createElement("button", {
    className: "Tag__delete-button icon-after icon-cross",
    type: "button",
    "aria-label": deleteButtonAriaLabel !== null && deleteButtonAriaLabel !== void 0 ? deleteButtonAriaLabel : t('atoms.tag.delete'),
    onClick: function onClick() {
      return onDelete(name);
    }
  }));
};
export default Tag;